import {
  FETCH_LOAD_TEMPLATE_BY_GIVEN_ID_REQUEST,
  FETCH_LOAD_TEMPLATE_BY_GIVEN_ID_SUCCESS,
  FETCH_LOAD_TEMPLATE_BY_GIVEN_ID_FALUIRE,
} from './loadTemplateByIDTypes'

const initialState = {
  loading: false,
  tempalteDataForUpdation: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_TEMPLATE_BY_GIVEN_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_TEMPLATE_BY_GIVEN_ID_SUCCESS : return {
      ...state,
      tempalteDataForUpdation: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_TEMPLATE_BY_GIVEN_ID_FALUIRE : return {
      ...state,
      loading: false,
      tempalteDataForUpdation: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
